/* eslint-disable no-alert */
import TestDriveRecord from '@/components/module/TestDriveRecord';
import TestDriveCore from '@/components/module/TestDriveCore';
import { verityInput } from '@/utils/util-extent';

const { $, location } = window;

export default class TestDriveSearch {
  constructor() {
    this.loading = false;
    this.$searchContent = $('.testdrive-search-content');
    this.$recordContent = $('.testdrive-record-content');
    this.$records = $('.testdrive-record-content .test-drive-result-list');

    this.$recordContent.hide();
    this.$searchContent.find('form').on('submit', this.onSearch.bind(this));
    // $('.test-drive-inquire-form button').on('click', this.onSearch.bind(this));
    this.initVaild();
  }

  initVaild() {
    this.$searchContent.find('#inputEmail').on('change', function change() {
      TestDriveCore.vaildity($(this), '無效的Email');
    });

    this.$searchContent.find('#inputPhone').on('change', function change() {
      TestDriveCore.vaildity($(this), '請輸入電話');
    });
  }

  onSearch(e) {
    // gaev('btn', 'click', 'btn_testdrive_search');
    if (e) e.preventDefault();

    const data = {};

    data.TEL = $('#inputPhone').val();
    if (!TestDriveCore.vaildity(this.$searchContent.find('#inputPhone'), '請輸入完整電話！', verityInput(data.TEL, 'num') === false)) {
      return;
    }
    data.EMAIL = $('#inputEmail').val();
    if (!TestDriveCore.vaildity(this.$searchContent.find('#inputEmail'), '無效的Email')) {
      return;
    }

    this.search(data);
  }

  search(data) {
    if (this.loading) return;
    this.loading = true;
    $.ajax({
      url: 'api/testdrive_search.ashx',
      type: 'POST',
      dataType: 'json',
      cache: 'false',
      data,
    })
      .done((e) => {
        if (e.RS === 'OK') {
          this.showRecord(e.DATA, data);
        } else {
          alert(e.RS);
        }
      })
      .fail((e) => {
        console.log('error', e);
      })
      .always(() => {
        this.loading = false;
      });
  }

  showRecord(data, extraData) {
    this.$records.empty();
    let record;
    data.forEach((element) => {
      const item = element;
      record = new TestDriveRecord(this.$records, item, extraData.TEL, extraData.EMAIL);
      record.on(TestDriveRecord.CANCEL, this.onRecordCanceled.bind(this));
    });
    this.$recordContent.find('#labphone').text(extraData.TEL);
    this.$recordContent.find('#labmail').text(extraData.EMAIL);
    this.$recordContent.show();
    this.$searchContent.hide();
  }

  onRecordCanceled() {
    const len = this.$records.children().length;
    if (len < 1) {
      // alert("查無紀錄");
      // location.reload();
      location.href = 'testdrive.aspx';
    }
  }
}
